export default __webpack_public_path__ + "static/media/card_b.84f7e5fd.png";